import { useEffect } from "react";

const PRODUCT_NAME = "NAGRA Venturi";

export function formatDocumentTitle(title?: string, section?: string) {
  const context = title === section ? title : [title, section].filter(Boolean).join(" · ");
  return context ? `${context} | ${PRODUCT_NAME}` : PRODUCT_NAME;
}

export function useDocumentTitle(title?: string, section?: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = formatDocumentTitle(title, section);

    return () => {
      document.title = previousTitle;
    };
  }, [section, title]);
}

export function DocumentTitle({ title }: { title?: string }) {
  useDocumentTitle(title);
  return null;
}
